import { useEffect, useState } from "react";

export function useMaxWidth(maxWidth) {
  const query = `(max-width: ${maxWidth}px)`;

  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia(query)?.matches ?? false;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;

    const mediaQuery = window.matchMedia(query);
    if (!mediaQuery) return undefined;

    const handleChange = (event) => setMatches(event.matches);
    setMatches(mediaQuery.matches ?? false);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}
